const failScoreStatus = ['MANUAL_REJECTED', 'AUTO_REJECTED', 'WAITING_APPROVAL'];

export const getFailureReasonText = (
  reason: string | null | undefined,
  scoreStatus: string | null | undefined
): string => {
  if (scoreStatus && !failScoreStatus.includes(scoreStatus)) return '-';
  if (!reason) return 'Falha genérica';

  const reasonMap: Record<string, string> = {
    USER_ID_VERIFICATION_PENDING_MANUAL_ANALYSIS: 'Cadastro em análise na Payface',
    UNEXPECTED_ERROR_IN_IDENTITY_PROVIDER: 'Erro no Provedor de identidade',
    USER_ID_VERIFICATION_FAIL_1_ONE_1: 'CPF incompatível com Rosto',
    UNEXPECTED_ERROR_IN_IDENTITY_VALIDATION_CHALLENGE: 'Erro na validação de CPF',
    USER_ID_VERIFICATION_FAIL_NEGATIVE_SCORE: 'Score negativo no provedor de identidade',
  };

  return reasonMap[reason] || 'Falha genérica';
};
